import "./SettingsForm.css"
import { useState } from "react";
import { LoadingSpinner } from "../../components";
import { Formik } from "formik";
import { Row, Col, Button, Form } from "react-bootstrap";
import SettingsImageForm from "./SettingsImageForm";
import SettingsVideoForm from "./SettingsVideoForm";


export default function SettingsForm(props) {
  // form for editing basic page settings like contact info and setting
  // header and footer images/video

  const [newFooterImage, setNewFooterImage] = useState(null);
  const [newTopImage, setNewTopImage] = useState(null);
  const [newTopVideo, setNewTopVideo] = useState(null);
  const [newLogo, setNewLogo] = useState(null);
  const [deletedImagesPublicIds, setDeletedImagesPublicIds] = useState([]);
  const [deletedVideosPublicIds, setDeletedVideosPublicIds] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState({}); //{topVideo: true}

  return (
    <Formik
      initialValues={{
        storeName: props.settingsData?.storeName || "",
        email: props.settingsData?.email || "",
        phone: props.settingsData?.phone || "",
        street: props.settingsData?.address?.street || "",
        city: props.settingsData?.address?.city || "",
        province: props.settingsData?.address?.province || "",
        postalCode: props.settingsData?.address?.postalCode || "",
        topImage: props.settingsData?.topImage || "",
        topVideo: props.settingsData?.topVideo || "",
        topOverlayText: props.settingsData?.topOverlayText || "",
        footerImage: props.settingsData?.footerImage || "",
        logo: props.settingsData?.logo || "",
      }}
      enableReinitialize={true} //automatically update initialValues to initialProductData once fetched from DB
      validationSchema={props.validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        // submit new data 
        const updatedData = {
          storeName: values.storeName,
          email: values.email,
          phone: values.phone,
          address: {
            street: values.street,
            city: values.city,
            province: values.province,
            postalCode: values.postalCode,
          },
          topOverlayText: values.topOverlayText,
        };
        if (deletedFiles.topImage) {
          updatedData.topImage = null;
        }
        if (deletedFiles.topVideo) {
          updatedData.topVideo = null;
        }
        if (deletedFiles.footerImage) {
          updatedData.footerImage = null;
        }
        if(deletedFiles.logo) {
          updatedData.logo = null; 
        }
        await props.handleSubmitClick(props.settingsData._id, updatedData, deletedImagesPublicIds, deletedVideosPublicIds, newTopVideo, newTopImage, newFooterImage, newLogo);
        setSubmitting(false);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        touched,
        errors,
        isSubmitting,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              {props.formFields.map((field, idx) => (
                <Form.Group key={idx} className="mb-3" controlId={field.name}>
                  <Form.Label>{field.label}</Form.Label>
                  {/* select with dropdown */}
                  {field.type === "select" ? (
                    <Form.Select
                      size="md"
                      aria-label="Default select example"
                      name={field.name}
                      value={values[field.name]}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                      onChange={(event) => {
                        handleChange(event);
                      }}
                    >
                      <option value="">Please Select</option>
                      {field.options.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control //regular field
                      type={field.type}
                      name={field.name}
                      value={values[field.name]}
                      onChange={handleChange}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                    />
                  )}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}









                                          {/* TOP IMAGE */}
                                          <SettingsImageForm 
                name="logo"
                heading="Logo"
                newImage={newLogo}
                setNewImage={setNewLogo}
                handleChange={handleChange}
                setDeletedImagesPublicIds={setDeletedImagesPublicIds}
                deletedImagesPublicIds={deletedImagesPublicIds}
                settingsData={props?.settingsData}
                values={values}
                setDeletedFiles={setDeletedFiles}
                deletedFiles={deletedFiles}
              />
            </Col>


            <Col md={1}></Col>

            {/* IMAGE & VIDEO INPUTS */}
            <Col md={5}>
              {/* FOOTER IMAGE */}
              <SettingsImageForm 
                name="footerImage"
                heading="Footer Image"
                newImage={newFooterImage}
                setNewImage={setNewFooterImage}
                handleChange={handleChange}
                setDeletedImagesPublicIds={setDeletedImagesPublicIds}
                deletedImagesPublicIds={deletedImagesPublicIds}
                settingsData={props?.settingsData}
                values={values}
                setDeletedFiles={setDeletedFiles}
                deletedFiles={deletedFiles}
              />

              {/* TOP VIDEO */}
              <SettingsVideoForm 
                name="topVideo"
                heading="Top Video"
                settingsData={props?.settingsData}
                setDeletedVideosPublicIds={setDeletedVideosPublicIds}
                deletedVideosPublicIds={deletedVideosPublicIds}
                newVideo={newTopVideo}
              setNewVideo={setNewTopVideo}
                handleChange={handleChange}
                setDeletedFiles={setDeletedFiles}
                deletedFiles={deletedFiles}
                values={values}

                />

              {/* TOP IMAGE */}
              <SettingsImageForm 
                name="topImage"
                heading="Top Image"
                newImage={newTopImage}
                setNewImage={setNewTopImage}
                handleChange={handleChange}
                setDeletedImagesPublicIds={setDeletedImagesPublicIds}
                deletedImagesPublicIds={deletedImagesPublicIds}
                settingsData={props?.settingsData}
                values={values}
                setDeletedFiles={setDeletedFiles}
                deletedFiles={deletedFiles}
              />

              {/* IMAGE OVERLAY TEXT */}
              <Form.Label>Image/Video Overlay Text</Form.Label>
              <Form.Control
                as="textarea"
                name="topOverlayText"
                value={values["topOverlayText"]}
                onChange={handleChange}
                maxLength={100}
                rows={2}
              />


            </Col>
          </Row>
          <Row>
            <Col className="mt-3">
              <Button type="submit">
                {isSubmitting && (
                  <LoadingSpinner button={true} variant="light" />
                )}{" "}
                Save
              </Button>
              <Button
                onClick={props.handleCancel}
                className="ms-3 cancel-button"
                type="button"
                variant="danger"
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
}
